import { IoStar } from "react-icons/io5";

const StarRating = ({ rating, totalReviews, uniqueStudentsReviewed }) => {
    const MAX_STARS = 5;
    const percentage = (rating / MAX_STARS) * 100;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
                flexDirection: "column",
            }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        fontSize: "20px",
                        lineHeight: "1",
                    }}>
                    {/* Gray stars (background) */}
                    <div style={{ color: "lightgray" }}>
                        {Array.from({ length: MAX_STARS }, (_, index) => (
                            <IoStar key={index} />
                        ))}
                    </div>

                    <div
                        style={{
                            color: "gold",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: `${percentage}%`,
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}>
                        {Array.from({ length: MAX_STARS }, (_, index) => (
                            <IoStar key={index} />
                        ))}
                    </div>
                </div>

                <p style={{ fontSize: "16px", color: "black" }}>
                    {rating != 0 ? rating : "NA"}
                </p>
            </div>
            <p style={{ fontSize: "13px" }}>
                Total reviews :{" "}
                {totalReviews != 0 && totalReviews != "NA"
                    ? totalReviews
                    : "NA"}{" "}
            </p>
            <p style={{ fontSize: "13px" }}>
                Unique students:{" "}
                {uniqueStudentsReviewed != 0 && uniqueStudentsReviewed != "NA"
                    ? uniqueStudentsReviewed
                    : "NA"}
            </p>
        </div>
    );
};

export default StarRating;
